<template>
  <div>
    <div
      v-if="showHeader"
      class="block-head">
      <h2>
        Отзывы
        <span
          v-if="reviews._meta && reviews._meta.totalCount"
          class="reviews-count">
          {{ reviews._meta.totalCount }}
        </span>
      </h2>
    </div>
    <div
      v-if="showNav"
      class="nav">
      <ul class="nav-list">
        <li class="nav-item">
          <nuxt-link
            :to="$i18n.path(path)"
            :class="
              $route.query.filter == undefined
                ? 'nav-link nav-link--active'
                : 'nav-link'
            ">
            Все
          </nuxt-link>
        </li>
        <li
          v-for="(item, index) in reviewsType"
          :key="index"
          class="nav-item">
          <nuxt-link
            :to="$i18n.path(path + '?filter=' + item.path)"
            :class="
              $route.query.filter == item.path
                ? 'nav-link nav-link--active'
                : 'nav-link'
            ">
            <template v-if="isAdminPage">
              {{ item.adminName }}
            </template>
            <template v-else>
              {{ item.name }}
            </template>
          </nuxt-link>
        </li>
      </ul>
    </div>
    <reviewsTable
      :reviews="reviews"
      :user-id="userId"
      :show-order-id="showOrderId"
      :show-id="showId"
      :show-buyer="showBuyer"
      :show-edit="showEdit"
      :show-reviews-count="showReviewsCount"
      :show-table-head="showTableHead"
      :update-entity="updateEntity"
      :show-price="showPrice"/>
  </div>
</template>

<script>
import reviewsTable from "~/components/tables/reviewsTable.vue";
export default {
  components: {
    reviewsTable
  },
  props: {
    reviews: {
      type: Object,
      default: null
    },
    userId: {
      type: Number,
      default: null
    },
    path: {
      type: String,
      default: ""
    },
    isAdminPage: {
      type: Boolean,
      default: false
    },
    showNav: {
      type: Boolean,
      default: true
    },
    showOrderId: {
      type: Boolean,
      default: true
    },
    showId: {
      type: Boolean,
      default: true
    },
    showTableHead: {
      type: Boolean,
      default: true
    },
    updateEntity: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showBuyer: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showReviewsCount: {
      type: Boolean,
      default: true
    },
    showPrice: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      backendUrl: process.env.backendUrl,
      pageState: {},
      reviewsType: [
        {
          id: 0,
          name: "Обо мне",
          adminName: "О пользователе",
          path: "to_user_id",
          active: false
        },
        {
          id: 1,
          name: "Написал я",
          adminName: "Написал пользователь",
          path: "from_user_id",
          active: false
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.nav {
  padding: 0 16px;
  font-size: 14px;
  border-bottom: 2px solid #eff1f4;
}
.nav-list {
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: flex-start;
  list-style: none;
}
.nav-item {
  margin-right: 36px;
}
.nav-link {
  position: relative;
  display: inline-block;
  padding: 9px 0 10px;
  color: #888888;
  cursor: pointer;
  &:after {
    position: absolute;
    content: "";
    top: 100%;
    left: 0;
    right: 0;
    height: 2px;
    background: #098aff;
    opacity: 0;
    transition: $link-transition;
  }
  &.nav-link--active {
    color: $blue;
    &:after {
      opacity: 1;
    }
  }
  &:not([href]):not([tabindex]) {
    color: #888888;
  }
}

.block-head{
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 25px;
    padding-left: 30px;
    padding-right: 16px;
    border-bottom: 2px solid #EFF1F4;
    h2{
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      font-size: 20px;
      font-weight: 500;
      span{
        margin-left: 8px;
        color: #6A6E76;
        font-weight: 500;
      }
      &:before{
        margin-right: 13px;
        display: inline-block;
        content: "";
        width: 27px;
        height: 19px;
        background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjAwMDMgMTAuMDAwM0MyMS44NDAzIDEwLjAwMDMgMjMuMzIwMyA4LjUwNjk5IDIzLjMyMDMgNi42NjY5OUMyMy4zMjAzIDQuODI2OTkgMjEuODQwMyAzLjMzMzY2IDIwLjAwMDMgMy4zMzM2NkMxOC4xNjAzIDMuMzMzNjYgMTYuNjY3IDQuODI2OTkgMTYuNjY3IDYuNjY2OTlDMTYuNjY3IDguNTA2OTkgMTguMTYwMyAxMC4wMDAzIDIwLjAwMDMgMTAuMDAwM1pNMTAuMDAwMyA4LjY2Njk5QzEyLjIxMzcgOC42NjY5OSAxMy45ODcgNi44ODAzMyAxMy45ODcgNC42NjY5OUMxMy45ODcgMi40NTM2NiAxMi4yMTM3IDAuNjY2OTkyIDEwLjAwMDMgMC42NjY5OTJDNy43ODY5OSAwLjY2Njk5MiA2LjAwMDMzIDIuNDUzNjYgNi4wMDAzMyA0LjY2Njk5QzYuMDAwMzMgNi44ODAzMyA3Ljc4Njk5IDguNjY2OTkgMTAuMDAwMyA4LjY2Njk5Wk0yMC4wMDAzIDEyLjY2N0MxNy41NjAzIDEyLjY2NyAxMi42NjcgMTMuODkzNyAxMi42NjcgMTYuMzMzN1YxOS4zMzM3SDI3LjMzMzdWMTYuMzMzN0MyNy4zMzM3IDEzLjg5MzcgMjIuNDQwMyAxMi42NjcgMjAuMDAwMyAxMi42NjdaTTEwLjAwMDMgMTEuMzMzN0M2Ljg5MzY2IDExLjMzMzcgMC42NjY5OTIgMTIuODkzNyAwLjY2Njk5MiAxNi4wMDAzVjE5LjMzMzdIMTAuMDAwM1YxNi4zMzM3QzEwLjAwMDMgMTUuMjAwMyAxMC40NDAzIDEzLjIxMzcgMTMuMTYwMyAxMS43MDdDMTIuMDAwMyAxMS40NjcgMTAuODgwMyAxMS4zMzM3IDEwLjAwMDMgMTEuMzMzN1oiIGZpbGw9IiMwOThBRkYiLz4KPC9zdmc+Cg==');
      }
    }
  }
</style>
